import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import LandscapePopup from "../../Components/ReuseablePopups/LandscapePopup";
import Sidebar from "../AdminNew/Sidebar";
import RotatePhone from './Assets/rotatePhone.png';
import DesktopTabsForWebsiteAnalytics from "./DesktopTabsForWebsiteAnalytics/DesktopTabsForWebsiteAnalytics";
import LiveFeed from "./LiveFeed/LiveFeed";
import Archive from "./Archive/Archive";
import Country from "./Country/Country";

const WebsiteAnalytics= () => {

    const [activeTab, setActiveTab] = useState("Live Feed");
    const [showPrompt, setShowPrompt] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);

     const [filters, setFilters] = useState({
            Email: '',
            FromDate : null,
            ToDate : null,
            Country: '',
            City: ''
     });

    const [appliedFilters, setAppliedFilters] = useState({
        Email: '',
        FromDate: null,
        ToDate: null,
        Country: '',
        City: ''
    });

    const handleApplyFilters = () => {
        setAppliedFilters({ ...filters });
        setFilterOpen(false);
    };

    const handleResetFilters = () => {
        const empty = { Email: '', FromDate: null, ToDate: null, Country: '',
        City: '' };
        setFilters(empty);
        setAppliedFilters(empty);
    };

    // Function to render the right-side content based on the active tab
    const renderContent = () => {
         switch (activeTab) {
            case "Live Feed":
                return <LiveFeed appliedFilters={appliedFilters}  />;
            case "Archive":
                return <Archive appliedFilters={appliedFilters}  />;
            case "Country":
                return <Country appliedFilters={appliedFilters}  />;         
            default:
         }
    };
    
    useEffect(() => {
    const isMobile = window.innerWidth < 1024;
    if (isMobile) {
        setShowPrompt(true);
    }
    }, []);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false)
    const [activeSidebarItem, setActiveSidebarItem] = useState("Visitors Hub")
    const handleSidebarItemClick = (item) => {
        setActiveSidebarItem(item)
        setIsSidebarOpen(false)
    }

    return (
        <div className="w-full min-h-screen bg-[#F7F7FC] relative pt-10">

        {/* Fixed Sidebar */}
            <Sidebar
                activeItem={activeSidebarItem}
                onItemClick={handleSidebarItemClick}
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
            />

            {showPrompt && ( 
                <LandscapePopup
                    setShowPopup={setShowPrompt}
                    heading="Please Rotate Your Phone"
                    text="For the best experience, kindly rotate your device to landscape mode to view this page properly."
                    btnText="Refresh page"
                    imageSrc={RotatePhone} // ✅ Dynamic image source
                />
            )}
            <main className="lg:ml-[260px] overflow-y-auto mb-6 relative">
                <DesktopTabsForWebsiteAnalytics setActiveTab={setActiveTab} activeTab={activeTab} setFilterOpen={setFilterOpen} filterOpen={filterOpen} filters={filters} setFilters={setFilters}
                onApply={handleApplyFilters}
                handleResetFilters={handleResetFilters} />
                <div className="pb-[100px] bg-[#FFFFFF]">
                        {renderContent()}
                </div>
            </main>

          
        </div>
    );
};

export default WebsiteAnalytics;
